import { Option } from 'app/types/interfaces/Option';
import { COUNTRY_CODES } from './Constant/country';

export enum DAY_OF_WEEK {
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday'
}

export const JOB_STATUS_OPTION: Array<Option> = [
  // { value: 'all', label: 'All Status' },
  {
    value: 'pendingAssign',
    label: 'Pending Assign'
  },
  {
    value: 'rejected',
    label: 'Schedule Rejected'
  },
  {
    value: 'waitingAccept',
    label: 'Waiting to Accept'
  },
  {
    value: 'scheduled',
    label: 'Scheduled'
  },
  {
    value: 'in-progress',
    label: 'In Progress'
  },
  {
    value: 'completed',
    label: 'Completed'
  }
];

export const RESULT_OPTIONS: Option[] = [
  // { value: 'all', label: 'All' },
  {
    value: 'passed',
    label: 'Passed'
  },
  {
    value: 'failed',
    label: 'Failed'
  },
  {
    value: 'pending',
    label: 'Pending'
  }
];

export const MIME_TYPES = {
  images: {
    jpg: ['image/jpg', 'image/jpeg', 'image/pjpeg'],
    png: 'image/png',
    gif: 'image/gif',
    svg: 'image/svg+xml'
  },
  documents: {
    doc: [
      'application/doc',
      'application/ms-doc',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    ],
    xls: [
      'application/excel',
      'application/vnd.ms-excel',
      'application/x-excel',
      'application/x-msexcel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    ],
    ppt: [
      'application/mspowerpoint',
      'application/powerpoint',
      'application/vnd.ms-powerpoint',
      'application/x-mspowerpoint',
      'application/vnd.openxmlformats-officedocument.presentationml.presentation'
    ],
    pdf: 'application/pdf',
    csv: 'text/csv'
  },
  others: {
    zip: 'application/zip'
  }
};

export { COUNTRY_CODES };
